<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Collection Limit Configuration</div>
        <div>
          <bread-crumb :bread-crumbs="['Collection Limit']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 mt-1 primary--text"></v-divider>
      <v-card-text>
        <!-- <v-card-title>
          <div style="font-size:17px;font-weight: bold;" class="mt-5">Collection Limit Configuration </div>
        </v-card-title> -->

        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :items="allcollection"
          sort-by="calories"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <!-- <v-toolbar-title>My CRUD</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider> -->

              <v-dialog persistent v-model="dialog" max-width="700px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn depressed 
                    color="primary"
                    dark
                    small
                    class="me-3 text-capitalize"
                    v-bind="attrs"
                    v-on="on"
                  >
                  <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add
                  </v-btn>

                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Type here to filter the table data."
                      single-line
                      hide-details
                      dense
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-btn depressed  @click="downloadExcelsheet" color="primary" small
                  ><v-icon small>mdi-file-excel-outline</v-icon>Export
                </v-btn>
                </template>
                <v-card flat>
                  <v-toolbar color="grey lighten-3 font-weight-bold" flat dense>
                    <span class="subtitleFontsize">{{ formTitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn depressed  small icon @click="close">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <!-- <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
   -->
                  <v-form>
                    <v-card-text class="mt-5">
                      <v-row>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 labelFontsize">
                            Collecting Country
                          </label>
                          <v-autocomplete
                            class="rounded"
                            :items="CountryList"
                            dense
                            outlined
                            v-model="Collectiondata.country_code"
                            disabled
                            background-color="grey lighten-4"
                            placeholder="Collecting Country"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 labelFontsize">Currency</label>
                          <v-autocomplete
                            class="rounded"
                            dense
                            outlined
                            placeholder="Currency"
                            :items="Currencylist"
                            v-model="Collectiondata.currency_code"
                            disabled
                            background-color="grey lighten-4"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 labelFontsize">
                            No.of Txn per Day
                          </label>
                          <v-text-field
                            class="rounded"
                            dense
                            outlined
                            placeholder="No.of Txn per Day"
                            v-model="Collectiondata.no_of_txn_per_day"
                            :error-messages="TxnperDay"
                            @input="
                              $v.Collectiondata.no_of_txn_per_day.$touch()
                            "
                            @blur="$v.Collectiondata.no_of_txn_per_day.$touch()"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <label class="my-0 labelFontsize">
                            No.of Txn Last 30 Days
                          </label>
                          <v-text-field
                            class="rounded"
                            dense
                            outlined
                            placeholder="No.of Txn Last 30 Days"
                            v-model="Collectiondata.no_of_txn_per_month"
                            :error-messages="Txnpermonth"
                            @input="
                              $v.Collectiondata.no_of_txn_per_month.$touch()
                            "
                            @blur="
                              $v.Collectiondata.no_of_txn_per_month.$touch()
                            "
                          ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" sm="6" md="6">
                      <label class="my-0 labelFontsize">
                        No.of Txn per Year
                      </label>
                      <v-text-field class="rounded" dense outlined placeholder=" No.of Txn per Year"></v-text-field>
                    </v-col> -->
                        <v-col cols="12" sm="6" md="6" v-if="!Collectiondata.id"
                          ><label class="my-0 labelFontsize">Remit Type</label>
                          <v-autocomplete
                            class="rounded"
                            dense
                            outlined
                            placeholder="Remit Type"
                            :items="items"
                            v-model="Collectiondata.remit_type"
                            :error-messages="remittype"
                            @input="$v.Collectiondata.remit_type.$touch()"
                            @blur="$v.Collectiondata.remit_type.$touch()"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-if="Collectiondata.id"
                          ><label class="my-0 labelFontsize">Remit Type</label>
                          <v-autocomplete
                            class="rounded"
                            dense
                            outlined
                            placeholder="Remit Type"
                            :items="items"
                            v-model="Collectiondata.remit_type"
                            :error-messages="remittype"
                            @input="$v.Collectiondata.remit_type.$touch()"
                            @blur="$v.Collectiondata.remit_type.$touch()"
                            disabled
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 labelFontsize">
                            Limit Per Day
                          </label>
                          <v-text-field
                            class="rounded"
                            dense
                            outlined
                            placeholder="Limit Per Day"
                            v-model="Collectiondata.coll_limit_per_day"
                            :error-messages="LimitPerDay"
                            @input="
                              $v.Collectiondata.coll_limit_per_day.$touch()
                            "
                            @blur="
                              $v.Collectiondata.coll_limit_per_day.$touch()
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <label class="my-0 labelFontsize">
                            Amount of Txn Last 30 Days
                          </label>
                          <v-text-field
                            class="rounded"
                            dense
                            outlined
                            placeholder="Amount of Txn Last 30 Days"
                            v-model="Collectiondata.coll_limit_per_month"
                            :error-messages="Amountlimit"
                            @input="
                              $v.Collectiondata.coll_limit_per_month.$touch()
                            "
                            @blur="
                              $v.Collectiondata.coll_limit_per_month.$touch()
                            "
                          ></v-text-field>
                        </v-col>
                      </v-row> </v-card-text
                  ></v-form>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <!-- <div class="d-flex">
                  <v-btn depressed  color="primary"  min-width="200px" @click="save()" 
                    class="me-3 text-capitalize">
                    Add
                  </v-btn>

                  <v-btn depressed  color="primary"  min-width="200px"  @click="close()" 
                    class="text-capitalize" outlined>
                    Cancel
                  </v-btn>
                </div> -->

                    <v-btn depressed 
                      small
                      color="primary"
                      class="text-capitalize"
                      @click="onclickNext()"
                      v-if="!Collectiondata.id"
                    >
                    <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add
                    </v-btn>
                    <v-btn depressed 
                      small
                      color="primary"
                      class="text-capitalize ms-2"
                      @click="close"
                      outlined
                      v-if="!Collectiondata.id"
                    >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
                    </v-btn>
                    <v-btn depressed 
                      small
                      color="primary"
                      class="text-capitalize"
                      @click="update()"
                      v-if="Collectiondata.id"
                    >
                    <v-icon small class="me-2">mdi-content-save-edit-outline</v-icon> Update
                    </v-btn>
                    <v-btn depressed 
                      small
                      color="primary"
                      class="text-capitalize ms-2"
                      @click="close"
                      outlined
                      v-if="Collectiondata.id"
                    >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
                    </v-btn>

                    <!-- <v-btn depressed  color="primary" class="text-capitalize ms-2" @click="close" outlined v-if="Collectiondata.id">
                    Cancel
                  </v-btn> -->
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" color="primary" @click="editItem(item)">
              mdi-content-save-edit-outline
            </v-icon>
            <v-icon
              small
              class="mr-2"
              @click="deleteItem(item)"
              color="primary"
            >
              mdi-trash-can-outline
            </v-icon>
          </template>
        </v-data-table>
        <v-dialog persistent v-model="openDialog" width="500">
          <v-card>
            <v-card-title class="border border-bottom">Delete</v-card-title>
            <v-card-text class="h5 py-3"
              >Are you sure you want to delete this Collection
              Limit?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed  small color="primary" outlined @click="onDeletecoll">
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn depressed  small color="primary" outlined @click="closeDelete()"
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <loading :active="loader" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import axios from "axios";
import Loading from "vue-loading-overlay";
import { required, numeric } from "vuelidate/lib/validators";
import alerts from "@/mixins/alerts";
// import { alpha } from "@/utils/validate"
export default {
  name: "Collection Limit",
  mixins: [alerts],
  data: () => ({
    dialog: false,
    search: "",
    loader: false,
    openDialog: false,
    CountryList: [],
    Currencylist: [],
    remit_type: "",
    items: ["I2I", "B2B", "I2B", "B2I"],
    headers: [
      {
        text: "Country",
        align: "start",
        sortable: false,
        value: "country_code",
      },
      { text: "Currency", value: "currency_code" },
      { text: "Remit Type", value: "remit_type" },
      { text: "No.of Txn per Day", value: "no_of_txn_per_day" },
      { text: "No.of Txn Last 30 Days", value: "no_of_txn_per_month" },
      // { text: 'No.of Txn per Year', value: 'protein' },
      { text: "Amount of Txn Last 30 Days", value: "coll_limit_per_month" },
      { text: "Limit Per Day", value: "coll_limit_per_day" },
      { text: "Action", value: "actions", sortable: false },
    ],
    allcollection: [],
    editedIndex: -1,
    Collectiondata: {
      country_code: "Malaysia",
      currency_code: "MYR",
      coll_limit_per_day: null,
      coll_limit_per_month: null,
      no_of_txn_per_day: null,
      no_of_txn_per_month: null,
      no_of_txn_per_year: null,
      remit_type: "",
    },
    defaultItem: {
      country_code: "Malaysia",
      currency_code: "MYR",
      coll_limit_per_day: null,
      coll_limit_per_month: null,
      no_of_txn_per_day: null,
      no_of_txn_per_month: null,
      no_of_txn_per_year: null,
      remit_type: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Add Collection Limit"
        : "Edit Collection Limit";
    },

    TxnperDay() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.Collectiondata.no_of_txn_per_day.$dirty) return errors;
      !this.$v.Collectiondata.no_of_txn_per_day.required &&
        errors.push(this.$t("Please Enter Transaction Limit"));
      !this.$v.Collectiondata.no_of_txn_per_day.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },
    Txnpermonth() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.Collectiondata.no_of_txn_per_month.$dirty) return errors;
      !this.$v.Collectiondata.no_of_txn_per_month.required &&
        errors.push(this.$t("Please Enter Transaction Limit"));
      !this.$v.Collectiondata.no_of_txn_per_month.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },
    LimitPerDay() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.Collectiondata.coll_limit_per_day.$dirty) return errors;
      !this.$v.Collectiondata.coll_limit_per_day.required &&
        errors.push(this.$t("Please Enter Transaction Limit"));
      !this.$v.Collectiondata.coll_limit_per_day.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },

    Amountlimit() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.Collectiondata.$dirty) return errors;
      !this.$v.Collectiondata.coll_limit_per_month.required &&
        errors.push(this.$t("Please Enter Transaction Limit"));
      !this.$v.Collectiondata.coll_limit_per_month.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },

    remittype() {
      const errors = [];
      if (!this.$v.Collectiondata.remit_type.$dirty) return errors;
      !this.$v.Collectiondata.remit_type.required &&
        errors.push(this.$t("Remit Type is requried"));
      return errors;
    },
  },
  components: {
    BreadCrumb,
    Loading,
  },
  validations() {
    return {
      Collectiondata: {
        no_of_txn_per_day: {
          required,
          numeric,
        },
        no_of_txn_per_month: {
          required,
          numeric,
        },
        coll_limit_per_day: {
          required,
          numeric,
        },
        coll_limit_per_month: {
          required,
          numeric,
        },
        remit_type: {
          required,
        },
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  //   created () {
  //     this.initialize()
  //   },
  mounted() {
    this.collectionlimit();
    this.getcountryList();
    this.getcurrency();
  },
  methods: {
    async downloadExcelsheet() {
      if (this.allcollection) {
        this.exportToExcel(this.headers, this.allcollection, "Collection");
      }
    },
    getcountryList() {
      axios({
        url: `${process.env.VUE_APP_COMMON_SERVICE}/api/v1/dropdown/all-countries`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.CountryList = response.data.data.map((i) => {
              return { text: i.country_name, values: i.iso_alpha3 };
            });
            this.CountryList.find((ele) => {
              if (ele.values == this.Collectiondata.country_code) {
                this.Collectiondata.country_code = ele.text;
              }
            });
          } 
          // else if (response.status === 401) {
          //   this.returnNewToken();
          //   this.getcountryList();
          // }

          console.log("Country", response);
        })
        .catch((e) => {
          console.error(e);
          this.CountryList = [];
        });
    },
    getcurrency() {
      axios({
        url: `${process.env.VUE_APP_COMMON_SERVICE}/api/v1/dropdown/all-countries`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.Currencylist = response.data.data.map((i) => {
              return { text: i.currency_code, values: i.country_name };
            });
          } 
          // else if (response.status === 401) {
          //   this.returnNewToken();
          //   this.getcurrency();
          // }
          console.log("currency", response);
        })
        .catch((e) => {
          console.error(e);
          this.CountryList = [];
        });
    },

    collectionlimit() {
      (this.loader = true),
        axios({
          url: `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/txn-limit/all-country-coll-limit`,
          headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
            accept: "application/json",
          },
        })
          .then((response) => {
            this.loader = false;
            if (response.data.status_code === 200) {
              this.allcollection = response.data.data;
            } 
            // else if (response.data.status_code === 401) {
            //   this.returnNewToken();
            //   this.collectionlimit();
            // }
            console.log("collectionlimit", response);
          })
          .catch((e) => {
            this.loader = false;
            console.error(e);
          });
    },
    editItem(item) {
      this.editedIndex = this.allcollection.indexOf(item);
      this.getcountryList();
      this.Collectiondata = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$v.$reset();
      this.$nextTick(() => {
        this.Collectiondata = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    onclickNext() {
      // console.log(
      //   `prametervalues: ${JSON.stringify(this.prametervalues)}`
      // );
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$emit("onNextClick", this.prametervalues);
      this.save();
    },

    ClickBack() {
      this.$emit("onClickBack");
    },

    save() {
      this.loader = true;

      if (this.editedIndex > -1) {
        Object.assign(
          this.allcollection[this.editedIndex],
          this.Collectiondata
        );
      } else {
        console.log("ii", this.Collectiondata);
        this.Collectiondata.country_code = "MYS";
        axios
          .post(
            `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/txn-limit/add-country-coll-limit?remit_type=${this.Collectiondata.remit_type}`,
            this.Collectiondata,

            {
              headers: {
                ContentType: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
                accept: "application/json",
              },
            },
            setTimeout(() => {
              this.loader = false;
            }, 300)
          )
          .then((responseData) => {
            console.log(`responseData: ${JSON.stringify(responseData)}`);
            if (responseData && responseData.data.status_code == 200) {
              this.showAlertSuccess(responseData.data.message);
              this.collectionlimit();
            }
            //  else if (responseData.data.status_code === 401) {
            //   this.returnNewToken();
            //   this.save();
            // }
          })
          .catch((error) => {
            console.log(error.response);
            this.showAlertError("Something went wrong please try again later.");
          });
      }
      this.close();
    },
    onupdate() {
      // console.log(
      //   `prametervalues: ${JSON.stringify(this.prametervalues)}`
      // );
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$emit("onNextClick", this.prametervalues);
      this.update();
    },
    update() {
      // alert('i am hitted')
      this.loader = true;
      if (this.editedIndex < -1) {
        Object.assign(
          this.allcollection[this.editedIndex],
          this.Collectiondata
        );
      } else {
        // this.Collectiondata.currency_code = "MYR"
        this.Collectiondata.country_code = "MYS";
        axios
          .put(
            `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/txn-limit/update-country-coll-limit?id=${this.Collectiondata.id}`,
            this.Collectiondata,

            {
              headers: {
                ContentType: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
                accept: "application/json",
              },
            },
            setTimeout(() => {
              this.loader = false;
            }, 300)
          )

          .then((responseData) => {
            console.log(`responseData: ${JSON.stringify(responseData)}`);
            if (responseData && responseData.data.status_code == 200) {
              this.showAlertSuccess(responseData.data.message);
              this.collectionlimit();
            }
            //  else if (responseData.data.status_code === 401) {
            //   this.returnNewToken();
            //   this.update();
            // }
          })
          .catch((error) => {
            console.log(error.response);
            this.showAlertError("Something went wrong please try again later.");
          });
      }

      this.close();
    },
    deleteItem(item) {
      this.openDialog = true;
      (this.remarks = item.remarks),
        (this.id = item.id),
        console.log("item", item);
    },
    closeDelete() {
      this.openDialog = false;
    },
    async onDeletecoll() {
      try {
        this.loader = true;
        const responseData = await this.$axios({
          url: `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/txn-limit/delete-country-coll-limit?id=${this.id}`,
          method: "DELETE",
          headers: { Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}` },
        });

        if (responseData && responseData.status === 200) {
          this.showAlertSuccess(responseData.data.message);
          this.loader = false;
          this.closeDelete();
          this.collectionlimit();
        } 
        // else if (responseData.data.status === 401) {
        //   this.returnNewToken();
        //   this.onDeletecoll();
        // }
      } catch (error) {
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
